module.exports = __webpack_public_path__ + "static/logo-hwcid1-bf8977d54c3788ef07bac50b3dce1539.png";